<template>
    <el-drawer :title="isEdit ? '编辑知识库' : '添加知识库'" :visible.sync="drawer" :modal="true" :wrapperClosable="false"
        size="600px" @close="closeDrawer" :modal-append-to-body="false" :direction="direction">

        <!-- title -->
        <div class="drawer_form">

            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">

                <div class="form-body">
                    <overlay-scrollbars style="width: 100%;height: 100%;" class="el-fade-in">
                        <el-form-item label="所属智能体" prop="agentId">
                            <el-select v-model="form.agentId" class="w-full" placeholder="请选择所属类别">
                                <el-option v-for="item in agents" :key="item.id" :label="item.agentName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="内容" prop="knowledgeText">
                            <el-input type="textarea" v-model="form.knowledgeText" autocomplete="off"
                                placeholder="请输入知识库内容" rows="4"></el-input>
                        </el-form-item>


                    </overlay-scrollbars>
                </div>

                <div class="form-foot d-flex a-center j-center">
                    <el-button @click="onSubmit" class="common-button">{{ isEdit ? '更新' : '添加' }}</el-button>
                </div>
            </el-form>
        </div>

    </el-drawer>

</template>

<script>
import { get, category, save } from '@/request/api/agents_knowledge.js';
import {list} from '@/request/api/agents.js';
export default {
    data() {
        return {
            drawer: true, //表单
            direction: 'rtl',//抽屉方向
            loading: false,
            isEdit: false, // 判断是编辑还是新增
            form: {
                id: '',
                agentId: '',
                knowledgeText: ''
            },
            agents: [],//智能体类别列表
            rules: {
                agentId: [
                    { required: true, message: '请选择所属智能体', trigger: 'blur' },
                ],
                knowledgeText: [
                    { required: true, message: '请输入知识库内容', trigger: 'blur' },
                ],
            }
        }
    },
    created() {
        // 判断是否为编辑模式
        this.isEdit = !!this.$route.query.id
        this.form.id = this.$route.query.id || ''
        this.init()
    },
    methods: {
        init() {
            // 获取智能体列表
            list().then(res => {
                if (res.data) {
                    this.agents = res.data
                }
            })
            // 如果是编辑模式，加载数据
            if (this.isEdit) {
                get({ id: this.form.id }).then(res => {
                    if (!res.data) return console.error("res.data is null");
                    Object.keys(this.form).forEach(item => {
                        if (Object.prototype.hasOwnProperty.call(this.form, item) && Object.prototype.hasOwnProperty.call(res.data, item)) {
                            this.form[item] = res.data[item]
                        }
                    })
                })
            }
        },
        onSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.req()
                } else {
                    return false;
                }
            });
        },

        //req
        req() {
            save(this.form).then(res => {
                if (res.code != 0) return this.$notify({ title: '失败', message: res.msg, type: 'error' });
                this.$notify({ title: '成功', message: this.isEdit ? "更新成功" : "添加成功", type: 'success' });
                this.$router.go(-1)
            })
        },



        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        //关闭抽屉
        closeDrawer() {
            this.$router.go(-1)
        }
    }

}
</script>


<style lang="less" scoped>
.drawer_form {
    width: 96%;
    margin: auto;

    .drawer_form_title {
        color: #17233d;
        font-size: 22px;
        font-weight: 400;
        text-align: center;
        line-height: 48px;
        margin-bottom: 20px;
    }

    .drawer_line {
        margin-bottom: 30px;

        .drawer_line_text {
            width: 120px;
            margin-right: 20px;
            text-align: right;
            color: #515a6e;
        }
    }

}

.form-items {
    background-color: #f5f6fb;
    padding: 15px 10px;
    height: 500px;
}

/deep/ .form-items .el-form-item,
/deep/ .form-items .el-form-item .el-form-item__content {
    width: 100%;
}
</style>
